import { AREA_TYPES, CURRENCY_OPTIONS } from "../aroundtown/PortfolioTable";
import { COUNTRIES } from "../../components/portfolioTable/constants";
import { BUILDING_SEGMENTS } from "../aroundtown/PortfolioTable";

export const DEFAULT_HEADERS = [
  { key: "name", text: "Building name", minWidth: 160, fixed: true },
  { key: "address", text: "Building address", minWidth: 300 },
  { key: "city", text: "City", minWidth: 150 },
  { key: "country", text: "Country", minWidth: 100, selectOptions: COUNTRIES },
  { key: "zip_code", text: "Zip", minWidth: 100 },
  { key: "total_square", text: "Total Building Area", minWidth: 150, type: "number" },
  { key: "roof_square", text: "Roof Area", minWidth: 100, type: "number" },
  {
    key: "area_type",
    text: "SQM/SQF",
    selectOptions: AREA_TYPES,
    valueFunc: (v) => v?.toUpperCase(),
  },
  {
    key: "segment",
    text: "Segment",
    selectOptions: BUILDING_SEGMENTS,
    valueFunc: (v) => v?.toUpperCase(),
  },
  { key: "total_unit", text: "Number of Units", minWidth: 100, type: "number" },
  { key: "total_tenants", text: "Number of Tenants", minWidth: 100, type: "number" },
  {
    key: "electricity_costs",
    text: "Total Electricity Costs (USD/EUR/GBP)",
    minWidth: 400,
    subHeaders: [
      { key: "2021", text: "2024", type: "number", minWidth: 100 },
      { key: "2022", text: "2025 (F)", type: "number", minWidth: 100 },
      { key: "2023", text: "2026 - Est.", type: "number", minWidth: 100 },
      { key: "currency", text: "Currency", type: "select", selectOptions: CURRENCY_OPTIONS },
    ],
  },
  {
    key: "electricity_consumption",
    text: "Estimated Electricity consumption (kWh)",
    minWidth: 300,
    subHeaders: [
      { key: "2021", text: "2024", type: "number", minWidth: 100 },
      { key: "2022", text: "2025 (F)", type: "number", minWidth: 100 },
      { key: "2023", text: "2026 - Est.", type: "number", minWidth: 100 },
    ],
  },
];

export const STATES = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "DC",
  "Delaware",
  "Florida",
  "Georgia",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const HOTEL_CLASSES_OPTIONS = ["3 stars", "4 stars", "5 stars", "5+ stars"];

export const HEALTHCARE_CLASSES_OPTIONS = ["Standard", "Premium", "Luxury"];

export const HOTEL_HEADERS = [
  ...DEFAULT_HEADERS.slice(0, 3),
  { key: "state", text: "State", minWidth: 150, selectOptions: STATES },
  ...DEFAULT_HEADERS.slice(3, 8),
  DEFAULT_HEADERS[9],
  ...DEFAULT_HEADERS.slice(11, 13),
];
